import { useState } from "react";
import { motion, useScroll } from "framer-motion";
import { ArrowUpRight, Download, Menu, X } from "lucide-react";
import { CALENDAR, RESUME } from "./data";

export function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { scrollYProgress } = useScroll();

  return (
    <>
      <motion.div className="scroll-progress" style={{ scaleX: scrollYProgress }} data-testid="scroll-progress" />
      <header className="nav">
        <div className="nav-inner" data-testid="site-navigation">
          <a href="#top" className="brand" data-testid="brand-home">
            <svg className="brand-logo" viewBox="0 0 64 64" aria-hidden="true">
              <rect x="4" y="4" width="56" height="56" rx="9" fill="none" stroke="currentColor" strokeWidth="4" />
              <text x="32" y="42" textAnchor="middle" fontFamily="JetBrains Mono, monospace" fontSize="25" fill="currentColor">S/</text>
            </svg>
            <span>Sandeep Sirodia</span>
          </a>
          <nav className={`nav-links ${menuOpen ? "is-open" : ""}`} data-testid="navigation-links">
            <a href="#work" onClick={() => setMenuOpen(false)} data-testid="nav-work-link">Selected work</a>
            <a href="#experience" onClick={() => setMenuOpen(false)} data-testid="nav-experience-link">Experience</a>
            <a href="#contact" onClick={() => setMenuOpen(false)} data-testid="nav-contact-link">Contact</a>
          </nav>
          <div className="nav-actions">
            <a className="text-link desktop-only" href={RESUME} target="_blank" rel="noreferrer" data-testid="nav-resume-link">
              <Download size={15} /> Resume
            </a>
            <a className="button button-small" href={CALENDAR} target="_blank" rel="noreferrer" data-testid="nav-book-call-button">
              Book a call <ArrowUpRight size={15} />
            </a>
            <button className="menu-button" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu" data-testid="mobile-menu-button">
              {menuOpen ? <X /> : <Menu />}
            </button>
          </div>
        </div>
      </header>
    </>
  );
}
